import React from 'react';
import { CommonModal } from '../../global/modal/common/common-modal';
import { IBlueprintItemDetails } from '../../../api/blueprints/blueprint-details.types';
import BlueprintItemDetails from './blueprint-item-details';
import './blueprint-details-popover.scss';
import Text from '../../global/text/text';
import { BLUEPRINT_SPACE_FROM_LEFT } from '../../../constants/common.constants';

export interface IBluePrintItemDetailsPopoverProps {
    template: IBlueprintItemDetails;
    title: string;
    closePopover: () => void;
}

const BluePrintItemDetailsPopover = ({
    closePopover,
    template,
    title,
}: IBluePrintItemDetailsPopoverProps) => {
    const isExist = !!template;
    if (!isExist) return null;

    return (
        <CommonModal
            title={title}
            isOpen={isExist}
            className='blueprint-details'
            onRequestClose={closePopover}
        >
            <Text
                tag='div'
                className='blueprint-details--name m-bottom-5px word-break'
                message={ template.name }
            />
            { template.description &&
                <Text
                    tag='div'
                    className='blueprint-details--description m-bottom-5px word-break'
                    message={ template.description }
                />
            }
            <div className='blueprint-details--settings m-top-26px'>
                {
                    template.templateDetailsSettings.map(settingItem => {
                        return <BlueprintItemDetails
                            key={settingItem.title}
                            settingItem={settingItem}
                            paddingLeft={BLUEPRINT_SPACE_FROM_LEFT}
                        />;
                    })
                }
            </div>
        </CommonModal>
    );
};

export default BluePrintItemDetailsPopover;
